import {
	type PartnerBalanceTransactionManualCreateDto,
	postPartnersPartnerIdBalanceTransactions,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getPartnerBalanceByPartnerIdQueryKey } from "Partner/Api/Query/useBalanceByPartnerId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useCreatePartnerBalanceTransactionMutation = (
	partnerId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(data: PartnerBalanceTransactionManualCreateDto) =>
				postPartnersPartnerIdBalanceTransactions(data, partnerId),
		),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerCreateBalanceTransactionError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(
				t(partnerMutationsResource.partnerCreateBalanceTransactionSuccess),
			);
			queryClient.invalidateQueries({
				queryKey: getPartnerBalanceByPartnerIdQueryKey(partnerId),
			});
		},
	});
};
